import * as React from 'react'
import { StoreProps } from '../../../services/stores/casting.store'
import CastingTooltipContainerDesktopComponent from './casting-tooltip-container-desktop.component'

export function useMountTooltipRef ({ data, store, step, tooltipPositionIsStable = true }: StoreProps & { step: 1 | 2 | 3, tooltipPositionIsStable?: boolean }) {
  const { focusedInput } = data
  const [currentTooltipElement, setCurrentTooltipElement] = React.useState<any>(null)
  const [currentTooltipRefInput, setCurrentTooltipRefInput] = React.useState<StoreProps['data']['focusedInput']>(null)

  const currentTooltip = React.useMemo(() => {
    if (!store.getFocusedInputInLegacyStep(step).includes(focusedInput)) return null
    if (!currentTooltipElement || focusedInput !== currentTooltipRefInput) return null
    if (!tooltipPositionIsStable) return null

    return <CastingTooltipContainerDesktopComponent key={ focusedInput } store={ store } data={ data } linkedInput={ currentTooltipElement } />
  }, [currentTooltipElement, currentTooltipRefInput, data, focusedInput, step, store, tooltipPositionIsStable])

  const mountTooltipRef = React.useCallback((newFocusedInput: StoreProps['data']['focusedInput']) => {
    if (focusedInput !== newFocusedInput) return undefined

    return (element: any) => {
      setCurrentTooltipElement(element)
      if (element && currentTooltipRefInput !== newFocusedInput) setCurrentTooltipRefInput(newFocusedInput)
      else if (!element && currentTooltipRefInput === newFocusedInput && focusedInput !== newFocusedInput) setCurrentTooltipRefInput(null)
    }
  }, [currentTooltipRefInput, focusedInput])

  return { currentTooltip, mountTooltipRef }
}